import React from "react";

export default function ActionSection() {
  return (
    <section className="action-section">
      <div className="section-inner action-inner">
        <div className="action-copy">
          <p className="section-tag">Momentum Shift</p>
          <h2>It is time to stop thinking. Let's act.</h2>
          <p>
            Your competitors are shipping content, testing creative, and
            capturing attention. We help you move with speed and confidence.
          </p>
        </div>
        <div className="action-card">
          <h3>Growth Sprint</h3>
          <ul>
            <li>Strategy in 7 days</li>
            <li>Creative in 14 days</li>
            <li>Launch in 21 days</li>
          </ul>
          <a className="btn primary" href="#contact">
            Start the sprint
          </a>
        </div>
      </div>
    </section>
  );
}
